module.exports = __webpack_public_path__ + "img/icon_guahao_02.d9c5a0c4.png";